// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"formula"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 12L20 13.4286L18 16M16 12L16 13.4286L18 16M18 16L16 18.5714L16 20M18 16L20 18.5714V20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 4H4V5.5L10 12L4 18.5V20H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FormulaIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'formula',
    ref,
    icon: element,
  },
));

FormulaIcon.displayName = 'FormulaIcon';

export default FormulaIcon;
